import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import './postEggCollectionInstruction.scss'; // Reusing preop checklist styles

export default function PostEggCollectionPrescription(props) {
  const [formData, setFormData] = useState({});
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');

  // Medication table headers
  const medicationHeaders = [
    {key: 'sno', label: 'S No.'},
    {key: 'brandName', label: 'Brand Name (Generic Name)'},
    {key: 'dose', label: 'Dose'},
    {key: 'frequency', label: 'Frequency'},
    {key: 'route', label: 'Route'},
    {key: 'duration', label: 'Duration'}
  ];

  // Initial medication data
  const [medicationRows, setMedicationRows] = useState([
    {sno: '1', brandName: 'Taxim-O (Cefixime)', dose: '200 mg', frequency: '1-0-1', route: 'Oral', duration: '5 days'},
    {sno: '2', brandName: 'PAN (Pantoprazole)', dose: '40 mg', frequency: '1-0-1', route: 'Oral', duration: '5 days'},
    {sno: '3', brandName: 'Zerodol-P (Aceclofenac + Paracetamol)', dose: '-', frequency: '1-0-1', route: 'Oral', duration: '5 days'},
    {sno: '4', brandName: 'T.Acton OR (Paracetamol)', dose: '1 GM', frequency: '1-1-1', route: 'Oral', duration: '5 days'},
    {sno: '5', brandName: 'SYRUP.Looz (Lactulose)', dose: '15 ml', frequency: '0-0-1', route: 'Oral', duration: '10 days'},
    {sno: '6', brandName: 'T.Cabgolin (Cabergoline)', dose: '0.5 mg', frequency: '0-0-1', route: 'Oral', duration: '8 days'},
    {sno: '7', brandName: 'T. Thyronorm (Levothyroxine sodium)', dose: '-', frequency: '1-0-0', route: 'Oral (empty stomach)', duration: '30 days'},
    {sno: '8', brandName: 'T.Glycomet (Metformin)', dose: '-', frequency: '1-0-1', route: 'Oral', duration: '30 days'},
    {sno: '9', brandName: 'Setrosil (Cetrorelix / Ganirelix Acetate)', dose: '0.25 mg', frequency: 'Single dose', route: 'SC', duration: '-'},
    {sno: '10', brandName: 'Calcium Gluconate', dose: '-', frequency: 'As advised', route: 'IV', duration: '-'},
    {sno: '11', brandName: 'HES (Hydroxyethyl Starch)', dose: '-', frequency: 'As advised', route: 'IV', duration: '-'},
    {sno: '12', brandName: 'STIMUCOR (Letrozole)', dose: '-', frequency: '1-0-0', route: 'Oral', duration: '10 days'}
  ]);

  const labelStyles = {
    fontWeight: '600',
    marginRight: '5px',
    width: 'max-content'
  };

  const [showTables, setShowTables] = useState({
    medicationTable: true
  });

  const handleNill = id => {
    setShowTables(prev => ({...prev, [id]: false}));
  };

  const handleChange = e => {
    const text = e.target.value;

    if (e.target.name === 'patientId1') {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {p_uhid: e.target.value};
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);

          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = `${data?.titles} ${data?.first_name} ${data?.last_name}`;

            if (e.target.name === 'patientId1') {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        };
        fetchData();
      } else {
        setFormData({...formData, patientId1: e.target.value});
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});

      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const renderDiscPoint = () => <span style={{fontSize: '30px', display: 'flex', alignItems: 'center', height: '20px'}}>●</span>;

  const renderIndentation = () => <span style={{visibility: 'hidden', fontSize: '30px', lineHeight: '20px'}}>●</span>;

  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;

    return (
      <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
        <label style={{...styleLabel, fontWeight: '600', marginRight: '5px', width: 'max-content'}}>{name}</label>
        <span style={styleSpan}>{value}</span>
      </section>
    );
  };

  const renderTableTD = value => {
    return <td style={{border: '1px solid black', textAlign: 'center'}}>{value}</td>;
  };

  const renderTableTH = value => {
    return <th style={{border: '1px solid black', textAlign: 'center'}}>{value}</th>;
  };

  const handlesubmit = () => {
    props.loaderchange('false');

    try {
      if (props.patientsData.id && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setShow(true);

        setTimeout(async () => {
          const htmlPayload = document.getElementById('prescriptionReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Post Egg Collection Prescription'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);

          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='PostEggCollection'>
      <div className='PostEggCollection'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img className='header_image' src={headerimage} style={{width: '100%', margin: '0 auto'}} alt='Clinic Header' />
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px'
            }}>
            {/* Patient ID */}
            <div style={{display: 'grid', gridTemplateColumns: '125px 16px 250px', alignItems: 'center'}}>
              <span style={{fontWeight: 600}}>Patient ID</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                value={props.patientsData.p_uhid}
                onChange={e => handleChange(e)}
                name='patientId'
                style={{border: '1px solid #ddd', outline: 'none', padding: '10px'}}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.p_uhid}</span>
            </div>

            {/* Patient Name */}
            <div style={{display: 'grid', gridTemplateColumns: '125px 16px 250px', alignItems: 'center'}}>
              <span style={{fontWeight: 600}}>Patient Name</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name='patientName'
                style={{border: '1px solid #ddd', outline: 'none', padding: '10px', color: '#000'}}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`} style={{width: '100%'}}>
                &nbsp;{`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            {/* Gender */}
            <div style={{display: 'grid', gridTemplateColumns: '125px 16px 250px', alignItems: 'center'}}>
              <span style={{fontWeight: 600}}>Gender</span>
              <span style={{fontWeight: 600}}>: </span>
              <select
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={props.patientsData.gender}
                name='gender'
                style={{border: '1px solid #ddd', outline: 'none', padding: '10px', backgroundColor: 'white'}}>
                <option value={props.patientsData.gender} selected>
                  {props.patientsData.gender}
                </option>
                <option value='Male'>Male</option>
                <option value='Female'>Female</option>
                <option value='Others'>Others</option>
                <option value='Decline to State'>Decline to State</option>
              </select>
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.gender}</span>
            </div>

            {/* Age */}
            <div style={{display: 'grid', gridTemplateColumns: '125px 16px 250px', alignItems: 'center'}}>
              <span style={{fontWeight: 600}}>Age</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={props.patientsData.age}
                name='age1'
                style={{border: '1px solid #ddd', outline: 'none', padding: '10px'}}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.age}</span>
            </div>
          </div>
        </div>

        {/* Medication Table */}
        <div className='detail py-3'>
          <h4 className='d-flex justify-content-center'>POST EGG COLLECTION PRESCRIPTION</h4>
        </div>

        {showTables.medicationTable && (
          <div className='detail'>
            <TemplateTable
              id='medicationTable'
              title=''
              headers={medicationHeaders}
              rows={medicationRows}
              onRowsChange={(id, newRows) => setMedicationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('medicationTable')}
            />
          </div>
        )}

        {/* Important Post-Procedure Information */}
        <div className='bulletin'>
          <h4>📄 IMPORTANT POST-PROCEDURE INFORMATION</h4>
          <ul className='px-3'>
            <li>
              ⏳ <strong>Discharge:</strong> Usually 6 hours post-procedure.
            </li>
            <li>
              💢 <strong>Expected symptoms:</strong> Mild pain, bloating, constipation, and spotting for up to 5 days.
            </li>
            <li>
              ✅ <strong>Recovery:</strong> Usually smooth and uneventful.
            </li>
            <li>
              📆 <strong>Next period</strong> may come earlier than expected.
            </li>
            <li>
              💊 <strong>Take all medications</strong> exactly as prescribed above.
            </li>
          </ul>
        </div>

        {/* Embryo & Freezing Information */}
        <div className='bulletin'>
          <h4>🧫 EMBRYO & FREEZING INFORMATION</h4>
          <ul className='px-3'>
            <li>
              🧬 <strong>Updates will be provided:</strong>
              <ul>
                <li>Day after egg retrieval</li>
                <li>Day 3 (cleavage stage)</li>
                <li>Day 5/6 (blastocyst stage)</li>
              </ul>
            </li>
            <li>
              💰 <strong>Freezing Charges:</strong> Based on the number of embryos (additional if &gt;4).
            </li>
            <li>
              🧬 <strong>PGT:</strong> To be paid if advised, after Day 5/6 embryo update.
            </li>
            <li>
              📅 <strong>Embryo Transfer:</strong> Planned after <strong>minimum 1-month break</strong>.
            </li>
          </ul>
        </div>

        {/* Follow-Up Plan */}
        <div className='bulletin'>
          <h4>📍 FOLLOW-UP PLAN</h4>
          <p>
            Please visit <strong>Dr. Aishwarya</strong> at ASCAS <strong>7 days after egg retrieval</strong> for planning embryo transfer.
          </p>
        </div>

        {/* Diet Tips */}
        <div className='bulletin'>
          <h4>🍲 POST-RETRIEVAL DIET TIPS</h4>
          <ul className='px-3'>
            <li>✅ Eat soft, nutritious foods: boiled eggs, dals, curd rice, fruits, vegetables.</li>
            <li>🤢 If nausea from anesthesia, consume bland foods (idli, kanji).</li>
            <li>
              🚨 <strong>Seek urgent help</strong> if you experience:
              <ul>
                <li>Severe bloating</li>
                <li>Shortness of breath</li>
                <li>Rapid weight gain</li>
              </ul>
            </li>
          </ul>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>

      {/* Report Generation Section */}
      <div id='prescriptionReport'>
        <div id='prescriptionReportWrap'>
          <Headers />
          <p className='Dani'></p>

          <div className='patient' style={{border: '1px solid black', borderRadius: '10px', marginBottom: '10px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>POST EGG COLLECTION PRESCRIPTION</h4>
          </div>

          {showTables.medicationTable && (
            <>
              <div>
                <table style={{marginBottom: '10px', border: '1px solid black', width: '100%', textAlign: 'center'}}>
                  <thead>
                    <tr>{medicationHeaders.map((header, index) => renderTableTH(header.label))}</tr>
                  </thead>
                  <tbody>
                    {medicationRows.map((row, index) => (
                      <tr key={index}>
                        {renderTableTD(row.sno)}
                        {renderTableTD(row.brandName)}
                        {renderTableTD(row.dose)}
                        {renderTableTD(row.frequency)}
                        {renderTableTD(row.route)}
                        {renderTableTD(row.duration)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          {/* Important Post-Procedure Information Report */}
          <div style={{display: 'flex', marginBottom: '10px'}}>{renderReportfield('📄 IMPORTANT POST-PROCEDURE INFORMATION', '', {styleSec: {width: '100%'}})}</div>
          {[
            '⏳ Discharge: Usually 6 hours post-procedure.',
            '💢 Expected symptoms: Mild pain, bloating, constipation, and spotting for up to 5 days.',
            '✅ Recovery: Usually smooth and uneventful.',
            '📆 Next period may come earlier than expected.',
            '💊 Take all medications exactly as prescribed above.'
          ].map((item, index) => (
            <div key={index} style={{display: 'flex', marginBottom: '10px'}}>
              {renderIndentation()}
              {renderDiscPoint()}
              {renderReportfield(item, '', {styleSec: {width: '100%'}})}
            </div>
          ))}

          {/* Embryo & Freezing Information Report */}
          <div style={{display: 'flex', marginBottom: '10px'}}>{renderReportfield('🧫 EMBRYO & FREEZING INFORMATION', '', {styleSec: {width: '100%'}})}</div>
          {[
            '🧬 Updates will be provided:',
            '   - Day after egg retrieval',
            '   - Day 3 (cleavage stage)',
            '   - Day 5/6 (blastocyst stage)',
            '💰 Freezing Charges: Based on the number of embryos (additional if >4).',
            '🧬 PGT: To be paid if advised, after Day 5/6 embryo update.',
            '📅 Embryo Transfer: Planned after minimum 1-month break.'
          ].map((item, index) => (
            <div key={index} style={{display: 'flex', marginBottom: '10px'}}>
              {renderIndentation()}
              {item.startsWith('   ') ? renderIndentation() : renderDiscPoint()}
              {renderReportfield(item, '', {styleSec: {width: '100%', marginLeft: item.startsWith('   ') ? '20px' : '0'}})}
            </div>
          ))}

          {/* Follow-Up Plan Report */}
          <div style={{display: 'flex', marginBottom: '10px'}}>{renderReportfield('📍 FOLLOW-UP PLAN', '', {styleSec: {width: '100%'}})}</div>
          <div style={{display: 'flex', marginBottom: '10px'}}>
            {renderIndentation()}
            {renderDiscPoint()}
            {renderReportfield('Please visit Dr. Aishwarya at ASCAS 7 days after egg retrieval for planning embryo transfer.', '', {styleSec: {width: '100%'}})}
          </div>

          {/* Diet Tips Report */}
          <div style={{display: 'flex', marginBottom: '10px'}}>{renderReportfield('🍲 POST-RETRIEVAL DIET TIPS', '', {styleSec: {width: '100%'}})}</div>
          {[
            '✅ Eat soft, nutritious foods: boiled eggs, dals, curd rice, fruits, vegetables.',
            '🤢 If nausea from anesthesia, consume bland foods (idli, kanji).',
            '🚨 Seek urgent help if you experience:',
            '   - Severe bloating',
            '   - Shortness of breath',
            '   - Rapid weight gain'
          ].map((item, index) => (
            <div key={index} style={{display: 'flex', marginBottom: '10px'}}>
              {renderIndentation()}
              {item.startsWith('   ') ? renderIndentation() : renderDiscPoint()}
              {renderReportfield(item, '', {styleSec: {width: '100%', marginLeft: item.startsWith('   ') ? '20px' : '0'}})}
            </div>
          ))}

          <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment : ', appointmentData.date?.split('-').reverse().join('-'))}</div>

          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
